import React from "react";
import { MOCK_PAYMENTS } from "../../utils/Api/mockPayments";

/**
 * Persistent marker shown whenever the dev mock payment rail is active.
 *
 * The point of the mock is that every screen behaves exactly as it does in
 * production - which means a mock "Payment successful" is indistinguishable
 * from a real one. This badge is the only thing that tells them apart, so it is
 * deliberately hard to miss and cannot be dismissed.
 */
export const DevMockBadge = () => {
  if (!MOCK_PAYMENTS) return null;

  return (
    <div
      role="status"
      aria-label="Development mock payments are active"
      style={{
        position: "fixed",
        left: 12,
        bottom: 12,
        zIndex: 2147483000,
        display: "flex",
        alignItems: "center",
        gap: 7,
        padding: "7px 12px",
        borderRadius: 999,
        background: "#c2451f",
        color: "#fff",
        fontFamily: "'Gilroy-Bold', system-ui, sans-serif",
        fontSize: 11,
        letterSpacing: "0.06em",
        boxShadow: "0 6px 16px rgba(2, 59, 82, 0.25)",
        pointerEvents: "none",
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: "50%",
          background: "#ffd6c9",
          display: "block",
        }}
      />
      DEV MOCK PAYMENTS — NO MONEY MOVES
    </div>
  );
};

export default DevMockBadge;
